<template>
  <div class="selector">
    <div
      v-for="(item, index) in selectors"
      @click="handleSelector(index)"
      :class="{'selected': selected == index, ['selected' + index]: selected == index}"
      :key="index"
      style="width: 50%; text-align: center;"
    >{{item}}</div>
  </div>
</template>

<script>
export default {
  props: {
    selectors: {
      type: Array
    },
    selected: {
      type: Number
    },
    handleSelector: {
      type: Function
    }
  }
};
</script>

<style lang="css" scoped>
.selector {
  display: flex;
  justify-content: space-around;
  font-size: 21px;
}

.selector > div {
  cursor: pointer;
  font-weight: bold;
  font-size: 1.5rem;
  /* padding: 8px 55px; */
  padding: 1.6875rem 0 1rem 0;
  transition: box-shadow 0.3s, color 0.3s;
  border-bottom: 2px groove;
}

.selector > div:hover {
  /* box-shadow: 0 2px 0px 0px  #16abbb; */
  border-bottom: 2px dashed;
  border-bottom-style: dotted;
}

.selected {
  color: #4a4a4a;
  border-bottom: none !important;
  /* box-shadow: 0 2px 0px 0px #16abbb; */
}

.selected0 {
  border-right: 2px groove;
}

.selected1 {
  border-left: 2px groove;
}

@media screen and (max-width: 450px) {
  .selector > div {
    padding: 8px 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/fixed/selector.vue